import React from "react"

const ConfirmDialog = ({
  open,
  title,
  message,
  confirmLabel,
  danger,
  loading,
  onConfirm,
  onCancel,
}) => {
  if (!open) return null

  return (
    <div className="fixed inset-0 bg-black/30 z-[60] flex items-center justify-center px-4">
      <div className="bg-white rounded-2xl border border-[#E7EAEF] max-w-sm w-full p-5">
        <h2 className="text-base font-semibold text-[#1F2937] mb-1">{title}</h2>
        <p className="text-sm text-[#9AA5B4] mb-4">{message}</p>

        <div className="flex gap-2">
          <button
            onClick={onConfirm}
            disabled={loading}
            className={`flex-1 px-3 py-2 rounded-xl text-sm font-medium text-white transition-colors
                        disabled:opacity-50 disabled:cursor-not-allowed
                        ${danger ? "bg-[#EF4444] hover:bg-[#DC2626]" : "bg-[#1F2937] hover:bg-[#111827]"}`}
          >
            {confirmLabel}
          </button>
          <button
            onClick={onCancel}
            className="flex-1 px-3 py-2 rounded-xl border border-[#E7EAEF] text-sm font-medium text-[#1F2937]
                       hover:bg-[#F4F6F9] transition-colors"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  )
}

export default ConfirmDialog
